<template>
    <div>
        <div class="polls-title">Poll & Surveys</div>
        <button class="btn btn-primary mb-3" @click="openPollModal">
            Add Question
        </button>
        <PollModal ref="modal" :event="event" />
        <div class="polls-g">
                <div v-for="cme in cmes" :key="cme.id">
                    <div>{{ cme.name }}</div>
                <div class="d-flex justify-content-between">
                    <template v-if="selectedCme != cme.id">
                        <div
                            class="btn launch-survey"
                            @click="triggerCme(false, cme.id)"
                        >
                            <img
                                src="/assets/new-moderator/Icon-Launch-Survey.svg"
                                alt=""
                            />
                            Launch Survey
                        </div>
                    </template>
                    <template v-else>
                        <button
                            class="btn pr"
                            @click="triggerCme(true, cme.id)"
                            v-if="poll_selected != true"
                        >
                            <img
                                src="/assets/new-moderator/Button-Publish-Result.svg"
                                alt=""
                            />
                            Publish Results
                        </button>
                        <button disabled="disabled" class="btn pr" v-else>
                            <img
                                src="/assets/new-moderator/Button-Publish-Result.svg"
                                alt=""
                            />
                            Published Results
                        </button>
                        <div class="btn oc" @click="OpenChat">
                            <img
                                src="/assets/new-moderator/Button-Open-Chat.svg"
                                alt=""
                            />
                            Open Chat
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import PollModal from "./QuizModal"; 
import $ from "jquery";    

export default {
    components: {
        PollModal,
    },
    props: ["event", "cmes"],
    data() {
        return {
            username: "testsuperadmin",
            password: "admin",
            polls: ["Where did you first hear about us?"],
            pollOptions: ["Hello", "Hoi", "Bye", "Lets Go"],
            selectedCme: "",
            poll_selected: false,
        };
    },
    mounted() {
        if (this.event.display_in_chat_box != null) {
            if (this.event.display_in_chat_box.type == "poll") {
                this.selectedCme = this.event.display_in_chat_box.data.cme_id;
            } else if (this.event.display_in_chat_box.type == "pollscore") {
                this.selectedCme = this.event.display_in_chat_box.data.cme_id;
                this.poll_selected = true;
            }
        }
        if (!localStorage.getItem("token")) {
            this.getToken();
        }
    },
    methods: {
        async getToken() {
            const API_URL = "https://devadmin-api.mymedisage.com/api";
            try {
                const data = await axios.post(`${API_URL}/login`, {
                    username: this.username,
                    password: this.password,
                });
                if (data.status) {
                    this.token = data?.data?.response?.token;
                    if (this.token) localStorage.setItem("token", this.token);
                }
            } catch (err) {
                console.log(err);
            }
        },
        openPollModal() {
            let element = this.$refs.modal.$el;
            $(element).modal("show");
        },
        triggerCme(score, id) {
            this.selectedCme = id;
            if (this.selectedCme != "") {
                let d = {
                    id: this.selectedCme,
                    score: score,
                };
                this.$emit("triggerEvent", {
                    data: d,
                    event: "onPollsTrigger",
                    type: score == true ? "score" : "poll",
                });
                if (score == true) {
                    this.poll_selected = true;
                }
            }
        },
        OpenChat() {
            let d = {
                id: this.selectedCme,
                openChat: true,
            };
            this.$emit("triggerEvent", {
                data: d,
                event: "onPollsTrigger",
                type: "openChat",
            });
            this.poll_selected = false;
            this.selectedCme = null;
        },
    },
};
</script>
<style scoped>
.launch-survey {
    display: inline-flex;
    background: #D7F9EF;
    color: #0BB783;
    font-weight: 600;
    font-size: 14px;
}
.btn:hover {
    color: #212529;
    text-decoration: none;
}
.pr {
    display: inline-flex;
    background: #EEE5FF;
    color: #8950FC;
    font-weight: 600;
    font-size: 14px;
}
.oc {
    display: inline-flex;
    background: #E1F0FF;
    color: #3699FF;
    font-weight: 600;
    font-size: 14px;
}
</style>
